module.exports = __webpack_public_path__ + "img/❶-c.9e4dce55.png";